<template>
  <div class="news">
    <div class="container">
      <el-breadcrumb class="breadcrumb pc" separator=">">
        <el-breadcrumb-item :to="{ path: '../../portal' }">
          <i class="iconfont iconyemiandaohang-shouye"></i>首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '../../teacherContent/' + this.id }">{{ teacherName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTypeName() }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="news-list content card-shadow" v-loading="loading">
        <div
          class="news-item can-click"
          :class="{ 'first': index === 0 }"
          v-for="(item, index) in news"
          :key="index"
          @click="viewNews(item)"
        >
          <div class="red-dot node-2"></div>
          <div class="news-info">
            <h1 class="name">{{ item.title }}</h1>
            <div class="introduction pc">{{ replaceTag(item.content) }}</div>
            <div class="time">发布时间：{{ item.updateTime }}</div>
          </div>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
          :hide-on-single-page="true"
        ></el-pagination>

        <div class="empty-tip" v-if="news.length === 0">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { teacherNews, teacherContent } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "teacherNews",
  props: {
    id: {
      type: String,
      default: "0"
    },
    type: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      teacherName: "",
      news: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loading: false
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      //监听路由是否变化
      this.init();
    }
  },
  methods: {
    init() {
      teacherContent(this.id)
        .then(res => {
          // 返回数据
          this.teacherName = res.info.name;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
        });

      this.getNews();
    },
    getNews() {
      this.loading = true;
      teacherNews({
        domain: this.id,
        type: this.type,
        pageSize: this.pageSize,
        pageNum: this.currentPage
      })
        .then(res => {
          // 返回数据
          this.news = res.list;
          this.total = res.total;

          this.loading = false;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
          this.loading = false;
        });
    },
    getTypeName() {
      let name = "";

      switch (this.type) {
        case "1":
          name = "近期动态";
          break;
        case "2":
          name = "理论文章";
          break;
        case "3":
          name = "媒体关注";
          break;
      }

      return name;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getNews();
    },
    viewNews(item) {
      this.$router.push(`${this.type}/${item.id}`);
    },
    replaceTag: util.replaceTag
  }
};
</script>

<style scoped>
.breadcrumb {
  margin-top: 20px;
}

.breadcrumb .iconfont {
  margin-right: 2px;
  font-size: 14px;
}

.content {
  margin-top: 20px;
  margin-bottom: 80px;
}

.empty-tip {
  padding-top: 30px;
}

.news-list {
  padding: 0 30px 30px;
  background-color: #fff;
  border: 1px solid #eee;
}

.news-item {
  position: relative;
  padding: 30px 0;
  border-top: 1px solid #eee;
}

.news-item.first {
  border: unset;
}

.news-item .red-dot {
  position: absolute;
  top: 38px;
  width: 10px;
  height: 10px;
  background-color: #c0392c;
  border-radius: 100%;
}

.tjxd .news-item .red-dot {
  background-color: #ec2f08;
}

.news-item .news-info {
  min-height: 112.5px;
  padding-left: 30px;
}

.news-item h1 {
  height: 52px;
  line-height: 26px;
  font-size: 18px;
  overflow: hidden;
}

.news-item .introduction {
  margin-top: 12px;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.news-item .time {
  margin-top: 10px;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: #888;
  overflow: hidden;
}

@media (max-width: 767px) {
  .content {
    margin-top: 5px;
    margin-bottom: 30px;
  }

  .news-list {
    padding: 0;
    border: unset;
  }

  .news-item {
    padding: 15px 0;
  }

  .news-item .red-dot {
    top: 30px;
  }

  .news-item .news-info {
    min-height: 67.5px;
    padding-left: 26px;
  }

  .news-item h1 {
    height: 40px;
    line-height: 20px;
    font-size: 14px;
  }
}
</style>